import React, { useContext } from 'react';
import { IModifiersContext, ModifiersContext } from '../../../modifiersState/modifiersContext';
import Text from 'components/Text/Text';
import { Item } from './Item';
import classNames from 'classnames';
import style from './index.module.scss';

export const ModifiersByCustomerList: React.FC = () => {
	const { modifiersByCustomer } = useContext<IModifiersContext>(ModifiersContext);

	const modifiersHeadingClasses = classNames(style.modifier, style.heading);
	const priceHeadingClasses = classNames(style.price, style.heading);
	const articleNumberHeadingClasses = classNames(style.articleNumber, style.heading);
	const restaurantsHeadingClasses = classNames(style.restaurants, style.heading);
	const actionHeadingClasses = classNames(style.action, style.heading);

	return (
		<div className={style.container} data-test="List">
			<div className={style.tableHeaders}>
				<Text
					className={modifiersHeadingClasses}
					translationNameSpace="listing"
					translationKey="modifierLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={restaurantsHeadingClasses}
					translationNameSpace="listing"
					translationKey="numberOfRestaurantsLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={priceHeadingClasses}
					translationNameSpace="listing"
					translationKey="priceLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={articleNumberHeadingClasses}
					translationNameSpace="listing"
					translationKey="articleNumberLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={actionHeadingClasses}
					translationNameSpace="listing"
					translationKey="actionLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
			</div>
			{modifiersByCustomer.items.map((item, index) => (
				<Item data={item} key={item.id + 'list'} index={index} />
			))}
		</div>
	);
};
